export default "__VITE_ASSET__30f3c393__"